import * as React from 'react';
import { useState, useEffect } from "react";
import Spinner from "../components/spinner.tsx";
import type { PageData } from "../data/pageData.ts";
import { editor, editorCode } from "../editor/editorFactory.ts";
import { renderEditorStateBrowser } from "../editor/renderEditorStateBrowser.ts";
import { fetchPageRenderReadyByUrl } from "./renderFunctionsData.ts";
import RenderContentWithCss from "./renderContentWithCss.tsx";

type Props = Readonly<{
	url: string
}>

function RenderPage({url}: Props) {
	const [page, setPage] = useState<PageData>(null);

	useEffect(() => {
		fetchPageRenderReadyByUrl(url, {
			editor: editor,
			editorCode: editorCode,
			renderEditorState: renderEditorStateBrowser
		}).then((page: PageData) => {
			setPage(page);
		});
	}, [url]);

	return (<>
		{page !== null ? <RenderContentWithCss pageContent={page?.content}/> : <div className="text-center my-48"><Spinner/></div>}
		{/*<Dump value={page}/>*/}
	</>);
}

export default RenderPage;
